import { ListItemIcon, MuiTooltip, ToggleOffIcon, ToggleOnIcon, useDispatch } from "@common";

const CommonToggleButton = ({ row, field, Action, getFunction }) => {
    const dispatch = useDispatch();
    const handleToggleClick = (event) => {
        event.stopPropagation();
        let payload;

        if (field === "isIntegrationEnabled") {
            payload = {
                id: row?.id,
                isIntegrationEnabled: !row?.isIntegrationEnabled,
            };
        } else {
            payload = {
                id: row?.id,
                integrationId: row?.integrationId,
            };

            if (field === "isActive") {
                payload.isActive = !row?.isActive;
            } else if (field === "isForAudit") {
                payload.isForAudit = !row?.isForAudit;
            }
        }
        dispatch(Action(payload)).then((res) => {
            if (res?.payload?.ok && getFunction) getFunction();
        });
    };
    const isDisabled = (field === "isForAudit") && !row?.isActive;
    const value = row?.[field];

    return (
        <MuiTooltip title={value ? "True" : "False"}>
            <ListItemIcon
                sx={{
                    cursor: isDisabled ? "not-allowed" : "pointer",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    opacity: isDisabled ? 0.5 : 1,
                    pointerEvents: isDisabled ? "none" : "auto",
                }}
                onClick={isDisabled ? undefined : handleToggleClick} >
                {value ? (
                    <ToggleOnIcon fontSize="large" style={{ color: "blue" }} />
                ) : (
                    <ToggleOffIcon fontSize="large" style={{ color: "grey" }} />
                )}
            </ListItemIcon>
        </MuiTooltip>
    );
};

export default CommonToggleButton;